module.exports = __webpack_public_path__ + "static/media/ultra.6384a991.png";